import * as React from 'react';
import { useSelector } from 'react-redux';
import { PublicationPrice } from './PublicationPrice';
import {
  selectActivePackage,
  selectActivePlacingType,
  selectPublicationPeriod,
} from '../../../../../../selectors/publishTerms';
import { formatMoney, pluralDays } from '../../../../../../utils/string';
import { EPlacingType } from '../../../../../../redux/reducers';
import { NBSP } from '../../../../../../constants/symbols';
import { useIsMobileDevice } from '../../../../../../hooks';

export const PublicationPriceContainer = () => {
  const placingType = useSelector(selectActivePlacingType);
  const publicationPeriod = useSelector(selectPublicationPeriod);
  const activePackage = useSelector(selectActivePackage);
  const isMobile = useIsMobileDevice();

  const { days: publicationDays = 1, price: publicationPrice = 0, isPaid } = publicationPeriod || {};
  const { days: packageDays = 1, price: packagePrice = 0 } = activePackage || {};

  if (placingType === EPlacingType.package) {
    const header = isMobile ? 'Публикация включена в пакет' : undefined;
    const title = isMobile
      ? `Вам не${NBSP}надо отдельно платить за${NBSP}публикацию${NBSP}— она входит в${NBSP}состав пакета`
      : 'Публикация включена в пакет';

    return (
      <PublicationPrice
        discountPrice={publicationPrice ? formatMoney(publicationPrice) : null}
        price={formatMoney(packagePrice)}
        days={pluralDays(packageDays, { excludeOne: true })}
        hintHeader={header}
        hintTitle={title}
      />
    );
  }

  // Объявление редактируется и пользователь платил деньги за публикацию (в некоторых регионах публикация бесплатна)
  if (isPaid && publicationPrice) {
    const header = isMobile ? 'Публикация уже оплачена' : undefined;
    const title = isMobile
      ? `Вам не${NBSP}надо отдельно платить за${NBSP}публикацию${NBSP}— вы${NBSP}оплатили её${NBSP}раньше`
      : 'Публикация уже оплачена';

    return (
      <PublicationPrice
        discountPrice={formatMoney(publicationPrice)}
        price={formatMoney(0)}
        days={pluralDays(publicationDays, { excludeOne: true })}
        hintHeader={header}
        hintTitle={title}
      />
    );
  }

  return (
    <PublicationPrice
      discountPrice={null}
      price={formatMoney(publicationPrice)}
      days={pluralDays(publicationDays, { excludeOne: true })}
    />
  );
};
